import React, { Fragment, useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";
import { Btn, H3, H4, P, Image } from "../../../AbstractElements";
import { useForm } from 'react-hook-form';
import { Row, Col, Container, Card, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input } from 'reactstrap'
import TableBuilder, { RegisteredInputsBuilder, ApiRequestBuilder, ToastBuilder, ModalButtonBuilder, FormOptionsBuilder } from '../../../GlobalComponents/Builders';
import { buildOptionsFromArray, renameKeysCamelToSnake, setInitialFormValues } from '../../../GlobalComponents/Helpers';
import { ContentLoader } from '../../../Layout/Loader';

document.title = 'View Service'

const ServiceSettings = () => {

    useEffect(() => {

    }, []);

    return (
        <Fragment>

        </Fragment>
    );
};
export default ServiceSettings;